import { HttpRepository } from 'infraestructure/repositories/';
import { FiniquitoResponse } from 'domain/models/Finiquito';

export class CreditRepository extends HttpRepository {
  endpoint = 'credit';

  simulate = async (type: number, amount: number): Promise<any> => {
    return await this.client.get(`${this.endpoint}/simulator`, {
      type,
      amount,
    });
  };

  getTcmCards = async (): Promise<any> => {
    return await this.client.get(
      `${this.endpoint}/simulator/GetCreditCardTypeTCMT`
    );
  };

  requestCredit = async (data: unknown): Promise<any> => {
    return await this.client.post(`${this.endpoint}/creditrequest`, data);
  };

  getFiniquito = async (codigo: string): Promise<FiniquitoResponse> => {
    const response = await this.client.get(`${this.endpoint}/Finiquito/${encodeURIComponent(codigo)}`);
    return response.data as FiniquitoResponse;
  };
}